import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const state = useMemo(() => {
    switch (command.data.state) {
      case 3:
        return 'Multicopter';
      case 4:
        return 'Fixed-wing';
      default:
        break;
    }
  }, [command.data.state]);

  return (
    <div className={cx('container')}>
      <label>
        State
        <div className={cx('fieldWrapper')}>
          <FieldText value={state} readOnly />
        </div>
      </label>
    </div>
  );
};

export default Item;
